module.exports = __webpack_public_path__ + "img/portrait_incorrect.d04c4948.png";